import { render } from "./DocumentPage.vue?vue&type=template&id=d41dc312"
import script from "./DocumentPage.vue?vue&type=script&lang=js"
export * from "./DocumentPage.vue?vue&type=script&lang=js"

import "./DocumentPage.vue?vue&type=style&index=0&id=d41dc312&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__